import classNames from 'classnames/bind'
import PropTypes from 'prop-types'
import React from 'react'

import styles from './styles.css'

const cx = classNames.bind(styles)

const Button = ({
  buttonClass = 'submit',
  children,
  disabled = false,
  onClick,
  paddingTB = '10px',
  paddingLR = '45px',
}) => {
  const buttonClasses = cx('button', {
    [styles[buttonClass]]: !disabled,
    disabled,
  })

  const inlineStyles = {
    padding: `${paddingTB} ${paddingLR}`,
  }
  return (
    <button
      className={buttonClasses}
      disabled={disabled}
      onClick={onClick}
      style={inlineStyles}
    >
      {children}
    </button>
  )
}

Button.propTypes = {
  buttonClass: PropTypes.oneOf(['submit', 'delete']),
  children: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  paddingTB: PropTypes.string,
  paddingLR: PropTypes.string,
}

export default Button



// WEBPACK FOOTER //
// ./src/components/sitewide/Button/index.js